import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  PipeTransform,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'gt-editable-field',
  templateUrl: './editable-field.component.html',
  styleUrls: ['./editable-field.component.scss']
})
export class EditableFieldComponent implements OnInit, OnChanges {
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() readOnly = false;
  @Input() editMode: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Input() formatter: PipeTransform;
  @Output() valueUpdated = new EventEmitter<string>();

  @ViewChild('theInput') theInput: ElementRef;
  @ViewChild('theFormField') theFormField: ElementRef;

  value = '';

  ngOnInit() {
    if (!this.formCtrl && !this.readOnly) {
      console.error('You must provide a form using the [formCtrl] @Input');
    }

    this.value = this.formCtrl.value;

    if (this.placeholder === null || this.placeholder === undefined) {
      this.placeholder = '';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.value = changes.formCtrl.currentValue.value;
  }

  editAttribute() {
    if (!this.readOnly) {
      this.editMode.next(true);
      setTimeout(() => {
        if (this.theInput) {
          this.theInput.nativeElement.focus();
          this.theInput.nativeElement.select();
        }
      }, 300);
    }
  }

  updateValue(event?: KeyboardEvent) {
    if (event) {
      event.preventDefault();
    }
    if (this.formCtrl.valid) {
      this.editMode.next(false);
      const value = this.formCtrl.value;
      if (value !== null && value !== undefined && value !== this.value) {
        this.value = value;
        this.valueUpdated.emit(value);
      }
      setTimeout(() => {
        if (this.theInput) {
          this.theInput.nativeElement.blur();
        }
      }, 300);
    } else {
      this.cancelEdit();
    }
  }

  cancelEdit($event?: KeyboardEvent) {
    this.editMode.next(false);
    this.formCtrl.setValue(this.value);
    if ($event) {
      $event.stopPropagation();
    }
  }

  toDisplay(): string {
    return this.formatter ? this.formatter.transform(this.value) : this.value;
  }
}
